module.exports = __webpack_public_path__ + "media/images/help/delivery/heading-mv-027cc234d33645ab78cfc7d56ecb43d1.svg";